import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {IReduxState} from '../../../../redux/types/IReduxState'
import {ComponentEnum, ComponentNameEnum} from '../../componentsRegistry/Registry'
import {taskActions} from '../../redux/actions'
import {Toolbar} from '../../toolbar/Toolbar'
import {ToolbarGroupTab} from '../../toolbar/ToolbarGroupTab'
import {ToolbarTab} from '../../toolbar/ToolbarTab'
import {ToolbarButtonImg} from '../../toolbar/ToolbarButtonImg'
import {acClose} from 'ac-icon'
import {WindowContent} from '../window/WindowContent'

interface ITaskDrawerModalProps {
  onSetWindowStyle: (newStyle: number) => void
}

const TaskDrawerModal: React.FC<ITaskDrawerModalProps> = ({onSetWindowStyle}): React.ReactElement => {
  const isDrawerModalOpen = useSelector<IReduxState, boolean>((state) => state.task?.isDrawerModalOpen)
  const drawerModalComponentId = useSelector<IReduxState, ComponentEnum | undefined>(
    (state) => state.task?.drawerModalComponentId,
  )
  const taskDispatch = useDispatch()
  const closeModal = (): void => {
    taskDispatch(
      taskActions.setState({
        isDrawerModalOpen: false,
        drawerModalComponentId: null,
      }),
    )
  }

  const closeModalShortcut = (evt): void => {
    if (evt.key === 'Escape') {
      closeModal()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', closeModalShortcut)

    return () => {
      document.removeEventListener('keydown', closeModalShortcut)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={'task-drawer-modal ' + (isDrawerModalOpen ? ' task-drawer-modal-open' : '')}>
      {isDrawerModalOpen && (
        <div className={'task-drawer-modal-header-and-content'}>
          <Toolbar>
            <ToolbarGroupTab>
              <ToolbarTab name={ComponentNameEnum[drawerModalComponentId]} isActive={true} />
            </ToolbarGroupTab>
            <ToolbarButtonImg title={'Закрыть'} onClick={closeModal} iconPath={acClose} />
          </Toolbar>
          <WindowContent
            id={drawerModalComponentId}
            componentId={drawerModalComponentId}
            className={'task-drawer-modal-content'}
            isShowStart={drawerModalComponentId === ComponentEnum.theory}
            onSetWindowStyle={onSetWindowStyle}
          />
        </div>
      )}
    </div>
  )
}

export {TaskDrawerModal}
